import {
  GET_ALL_USER,
  GET_ALL_USER_SUCCESS,
  GET_ALL_USER_FAIL,
} from "./actionTypes"

//Get User
export const getAllUsers = () => ({
  type: GET_ALL_USER,
})
export const getAllUsersSuccess = users => ({
  type: GET_ALL_USER_SUCCESS,
  payload: users,
})
export const getAllUsersFail = error => ({
  type: GET_ALL_USER_FAIL,
  payload: error,
})
